// NGL SERVICES - Mock Data - SEO Optimisé Vitrerie Val-de-Marne (94)
// Focus: vitrier villiers-sur-marne, vitrier 94, sans aucune référence à Paris

export const companyInfo = {
  name: "NGL SERVICES",
  tagline: "Vitrier & Menuisier à Villiers-sur-Marne (94)",
  description: "NGL SERVICES, votre vitrier à Villiers-sur-Marne (94). Spécialiste remplacement vitre cassée, bris de glace, double vitrage, miroiterie. Urgence 24h/24, intervention rapide Val-de-Marne. Devis gratuit.",
  phone: "01 84 21 13 11",
  phoneEmergency: "07 81 55 90 50",
  email: "comptaglotech@gmail.com",
  address: "Villiers-sur-Marne, 94350",
  emergencyHours: "24h/24 – 7j/7",
  logo: "https://customer-assets.emergentagent.com/job_ngl-menuiserie/artifacts/yybak1lr_LOGO%20NGL%20SERVICES.png"
};

// Mots-clés SEO Val-de-Marne (94) - SANS PARIS
export const seoKeywordsValDeMarne = {
  vitrier: [
    "vitrier villiers-sur-marne",
    "vitrier champigny-sur-marne",
    "vitrier bry-sur-marne",
    "vitrier nogent-sur-marne",
    "vitrier noisy-le-grand",
    "vitrier saint-maur-des-fossés",
    "vitrier créteil",
    "vitrier le-perreux-sur-marne",
    "vitrier neuilly-sur-marne",
    "vitrier neuilly-plaisance",
    "vitrier gournay-sur-marne",
    "vitrier le-plessis-trévise",
    "vitrier chennevières-sur-marne",
    "vitrier 94",
    "vitrier val-de-marne",
    "vitrier urgence villiers-sur-marne",
    "vitrier dépannage 94",
    "vitrier autour de moi 94",
    "artisan vitrier 94",
    "miroitier val-de-marne"
  ],
  brisDeGlace: [
    "remplacement vitre cassée",
    "changement double vitrage",
    "changer vitre double vitrage",
    "bris de glace habitation",
    "bris de glace 94",
    "découpe de verre autour de moi",
    "réparation vitrage fenêtre",
    "vitre cassée urgence",
    "carreau double vitrage",
    "vitrage sécurit",
    "verre feuilleté",
    "vitrerie à proximité",
    "vitrerie autour de moi"
  ],
  menuiserie: [
    "dépose totale fenêtre",
    "dépose totale ou rénovation fenêtre",
    "remplacement fenêtre PVC",
    "rénovation fenêtres double vitrage",
    "fenêtre double vitrage rénovation",
    "double vitrage rénovation",
    "double vitrage acoustique",
    "double vitrage phonique",
    "fenêtre ancienne double vitrage",
    "menuisier vitrier",
    "menuisier val-de-marne"
  ],
  longTail: [
    "astuce pour lisser mastic vitrier",
    "crémone définition",
    "joint étanchéité fenêtre",
    "mastic vitrier pose",
    "temps séchage mastic vitrier",
    "verre sécurit anti-effraction",
    "verre armé",
    "vitrage photovoltaïque"
  ]
};

export const services = [
  {
    id: "vitrerie",
    title: "Vitrier - Vitrerie & Miroiterie",
    shortDesc: "Vitrier à Villiers-sur-Marne et Val-de-Marne (94) - Remplacement vitre cassée, bris de glace, double vitrage",
    description: "NGL SERVICES, votre vitrier à Villiers-sur-Marne et dans tout le Val-de-Marne (94). Intervention rapide pour remplacement de vitre cassée, bris de glace, installation double vitrage et triple vitrage. Service d'urgence vitrerie 24h/24 et 7j/7. Artisan vitrier qualifié, miroitier professionnel pour Champigny-sur-Marne, Bry-sur-Marne, Nogent-sur-Marne, Saint-Maur-des-Fossés, Créteil, Noisy-le-Grand.",
    features: [
      "Remplacement vitre cassée en urgence",
      "Réparation bris de glace habitation",
      "Installation double vitrage rénovation",
      "Pose triple vitrage isolant",
      "Vitrage feuilleté sécurité",
      "Dépannage vitrier 24h/24 Val-de-Marne",
      "Miroitier - Miroirs sur mesure",
      "Vitrine commerce",
      "Découpe de verre sur mesure",
      "Vitrage sécurit anti-effraction"
    ],
    image: "https://images.pexels.com/photos/323776/pexels-photo-323776.jpeg?auto=compress&cs=tinysrgb&w=800",
    icon: "Glass",
    seoKeywords: ["vitrier villiers-sur-marne", "vitrier 94", "vitre cassée", "bris de glace", "remplacement vitre", "double vitrage", "vitrier urgence", "miroitier val-de-marne", "vitrerie à proximité", "vitrier champigny-sur-marne", "vitrier nogent-sur-marne", "vitrier créteil", "vitrier saint-maur-des-fossés"]
  },
  {
    id: "fenetres",
    title: "Fenêtres PVC/Alu/Bois",
    shortDesc: "Installation et remplacement fenêtres PVC, aluminium et bois - Val-de-Marne (94)",
    description: "Installation et remplacement de fenêtres en PVC, aluminium ou bois à Villiers-sur-Marne et dans le Val-de-Marne. Menuiseries de qualité pour améliorer l'isolation thermique et phonique. Double vitrage rénovation, fenêtre ancienne double vitrage. Dépose totale ou rénovation fenêtre. Devis gratuit.",
    features: [
      "Fenêtres PVC haute isolation",
      "Fenêtres aluminium design",
      "Fenêtres bois traditionnelles",
      "Fenêtres oscillo-battantes",
      "Baies vitrées coulissantes",
      "Dépose totale fenêtre sans dégâts",
      "Double vitrage rénovation",
      "Double vitrage acoustique et phonique",
      "Rénovation fenêtres double vitrage",
      "Joint étanchéité fenêtre"
    ],
    image: "https://images.unsplash.com/photo-1666310839701-82ee7b46a170?auto=format&fit=crop&w=800&q=80",
    icon: "LayoutGrid",
    seoKeywords: ["fenêtre PVC", "fenêtre aluminium", "menuiserie val-de-marne", "double vitrage rénovation", "dépose totale fenêtre", "fenêtre double vitrage rénovation", "remplacement fenêtre PVC", "fenêtre ancienne double vitrage"]
  },
  {
    id: "portes-entree",
    title: "Portes d'entrée",
    shortDesc: "Portes d'entrée sécurisées à Villiers-sur-Marne",
    description: "Installation de portes d'entrée alliant sécurité, isolation et esthétique à Villiers-sur-Marne. Large choix de modèles en PVC, aluminium, bois ou mixte.",
    features: [
      "Portes blindées et sécurisées",
      "Portes PVC économiques",
      "Portes aluminium modernes",
      "Portes bois authentiques",
      "Serrures multipoints",
      "Isolation thermique et phonique"
    ],
    image: "https://images.unsplash.com/photo-1636095643831-efebe5813a09?auto=format&fit=crop&w=800&q=80",
    icon: "DoorOpen",
    seoKeywords: ["porte entrée", "porte blindée", "porte sécurisée Villiers-sur-Marne"]
  },
  {
    id: "volets",
    title: "Volets Roulants & Battants",
    shortDesc: "Volets roulants et battants à Villiers-sur-Marne",
    description: "Pose et réparation de volets roulants manuels ou motorisés, ainsi que volets battants en aluminium, PVC ou bois à Villiers-sur-Marne.",
    features: [
      "Volets roulants motorisés",
      "Volets roulants manuels",
      "Volets battants aluminium",
      "Volets battants bois",
      "Réparation et dépannage",
      "Motorisation de volets existants"
    ],
    image: "https://images.unsplash.com/photo-1600331213614-6a51ae5c8d8f?auto=format&fit=crop&w=800&q=80",
    icon: "Blinds",
    seoKeywords: ["volet roulant", "volet battant", "motorisation volet Villiers-sur-Marne"]
  },
  {
    id: "portes-garage",
    title: "Portes de Garage",
    shortDesc: "Portes de garage à Villiers-sur-Marne",
    description: "Installation et réparation de portes de garage sectionnelles, basculantes, enroulables ou coulissantes à Villiers-sur-Marne. Motorisation disponible.",
    features: [
      "Portes sectionnelles",
      "Portes basculantes",
      "Portes enroulables",
      "Motorisation automatique",
      "Réparation et entretien",
      "Télécommandes et accessoires"
    ],
    image: "https://images.unsplash.com/photo-1647843097965-3686dadb7b84?auto=format&fit=crop&w=800&q=80",
    icon: "Warehouse",
    seoKeywords: ["porte garage", "porte sectionnelle", "motorisation garage Villiers-sur-Marne"]
  },
  {
    id: "serrurerie",
    title: "Serrurerie & Dépannage",
    shortDesc: "Serrurier dépannage urgence 24h/24 à Villiers-sur-Marne",
    description: "Service de serrurerie et dépannage d'urgence disponible 24h/24 et 7j/7 à Villiers-sur-Marne. Ouverture de porte, changement de serrure, blindage.",
    features: [
      "Ouverture de porte claquée",
      "Remplacement de serrure",
      "Installation serrure multipoints",
      "Blindage de porte",
      "Dépannage urgent 24h/24",
      "Cylindre haute sécurité"
    ],
    image: "https://images.unsplash.com/flagged/photo-1564767609213-c75ee685263a?auto=format&fit=crop&w=800&q=80",
    icon: "KeyRound",
    seoKeywords: ["serrurier", "serrurier urgence", "ouverture porte Villiers-sur-Marne"]
  }
];

export const cities = [
  { id: "villiers-sur-marne", name: "Villiers-sur-Marne", postalCode: "94350", isPrimary: true },
  { id: "noisy-le-grand", name: "Noisy-le-Grand", postalCode: "93160", isPrimary: false },
  { id: "bry-sur-marne", name: "Bry-sur-Marne", postalCode: "94360", isPrimary: false },
  { id: "champigny-sur-marne", name: "Champigny-sur-Marne", postalCode: "94500", isPrimary: false },
  { id: "le-plessis-trevise", name: "Le Plessis-Trévise", postalCode: "94420", isPrimary: false },
  { id: "chennevieres-sur-marne", name: "Chennevières-sur-Marne", postalCode: "94430", isPrimary: false },
  { id: "le-perreux-sur-marne", name: "Le Perreux-sur-Marne", postalCode: "94170", isPrimary: false },
  { id: "neuilly-sur-marne", name: "Neuilly-sur-Marne", postalCode: "93330", isPrimary: false },
  { id: "gournay-sur-marne", name: "Gournay-sur-Marne", postalCode: "93460", isPrimary: false },
  { id: "neuilly-plaisance", name: "Neuilly-Plaisance", postalCode: "93360", isPrimary: false },
  { id: "saint-maur-des-fosses", name: "Saint-Maur-des-Fossés", postalCode: "94100", isPrimary: false },
  { id: "nogent-sur-marne", name: "Nogent-sur-Marne", postalCode: "94130", isPrimary: false },
  { id: "creteil", name: "Créteil", postalCode: "94000", isPrimary: false },
  { id: "torcy", name: "Torcy", postalCode: "77200", isPrimary: false }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie D.",
    city: "Villiers-sur-Marne",
    rating: 5,
    text: "Vitre cassée suite à une tentative d'effraction. Le vitrier NGL SERVICES est intervenu en moins d'une heure pour le remplacement. Travail impeccable, je recommande !",
    service: "Vitrerie"
  },
  {
    id: 2,
    name: "Jean-Pierre L.",
    city: "Villiers-sur-Marne",
    rating: 5,
    text: "Excellent travail pour le remplacement de notre double vitrage. Le vitrier était professionnel et le résultat parfait. Devis respecté.",
    service: "Vitrerie"
  },
  {
    id: 3,
    name: "Sophie M.",
    city: "Champigny-sur-Marne",
    rating: 5,
    text: "Bris de glace sur ma baie vitrée, intervention d'urgence le dimanche. Vitrier compétent et tarif raisonnable. Merci NGL SERVICES !",
    service: "Vitrerie"
  },
  {
    id: 4,
    name: "Laurent B.",
    city: "Noisy-le-Grand",
    rating: 5,
    text: "Porte claquée un samedi soir, le serrurier est arrivé en 30 minutes. Ouverture sans dégât et prix correct. Service au top !",
    service: "Serrurerie"
  }
];

export const aboutContent = {
  title: "À propos de NGL SERVICES - Vitrier à Villiers-sur-Marne",
  subtitle: "Votre artisan vitrier et menuisier de confiance dans le Val-de-Marne",
  paragraphs: [
    "NGL SERVICES est votre vitrier de référence à Villiers-sur-Marne (94350). Spécialisés dans le remplacement de vitre cassée, la réparation de bris de glace et l'installation de double vitrage, nous intervenons en urgence 24h/24 et 7j/7 dans tout le Val-de-Marne.",
    "Notre équipe d'artisans vitriers qualifiés intervient rapidement pour tous vos besoins en vitrerie : vitre simple, double vitrage, triple vitrage, vitrage feuilleté de sécurité, miroirs sur mesure et vitrines de commerce.",
    "En plus de nos services de vitrerie, NGL SERVICES propose également la menuiserie extérieure (fenêtres, portes, volets) et la serrurerie. Disponibles 24h/24 pour les urgences, nous nous engageons à vous offrir un service de qualité avec des tarifs transparents."
  ],
  values: [
    { title: "Urgence 24h/24", description: "Vitrier disponible jour et nuit pour vos urgences vitrerie" },
    { title: "Intervention rapide", description: "Arrivée sur place en moins d'une heure à Villiers-sur-Marne" },
    { title: "Devis gratuit", description: "Estimation transparente et sans engagement" },
    { title: "Artisan qualifié", description: "Vitriers expérimentés et certifiés" }
  ]
};

export const formOptions = {
  requestTypes: [
    { value: "depannage", label: "Dépannage urgent" },
    { value: "intervention", label: "Intervention programmée" },
    { value: "devis", label: "Demande de devis" },
    { value: "renovation", label: "🏠 Rénovation avec facilité de paiement" }
  ],
  clientTypes: [
    { value: "particulier", label: "Particulier" },
    { value: "professionnel", label: "Professionnel / Entreprise" },
    { value: "association", label: "Association" },
    { value: "immobilier", label: "Agence immobilière / Syndic" },
    { value: "autre", label: "Autre" }
  ],
  serviceTypes: [
    { value: "vitrerie", label: "Vitrerie (vitre cassée, bris de glace)" },
    { value: "double-vitrage", label: "Double vitrage / Triple vitrage" },
    { value: "baie-vitree", label: "Baie vitrée" },
    { value: "vitrine", label: "Vitrine commerce" },
    { value: "miroiterie", label: "Miroiterie / Miroirs" },
    { value: "serrurerie", label: "Serrurerie" },
    { value: "menuiserie", label: "Menuiserie (fenêtres, portes)" },
    { value: "volets", label: "Volets" },
    { value: "garage", label: "Porte de garage" },
    { value: "autre", label: "Autre" }
  ],
  housingTypes: [
    { value: "maison", label: "Maison individuelle" },
    { value: "appartement", label: "Appartement" },
    { value: "immeuble", label: "Immeuble / Copropriété" },
    { value: "commerce", label: "Commerce / Local professionnel" },
    { value: "bureau", label: "Bureau / Entreprise" },
    { value: "autre", label: "Autre" }
  ],
  accessTypes: [
    { value: "facile", label: "Accès facile (RDC, parking proche)" },
    { value: "moyen", label: "Accès moyen (étage avec ascenseur)" },
    { value: "difficile", label: "Accès difficile (étage sans ascenseur, échafaudage)" }
  ],
  // Options Rénovation - Facilité de paiement
  renovationPropertyTypes: [
    { value: "maison", label: "Maison" },
    { value: "appartement", label: "Appartement" },
    { value: "commerce", label: "Commerce" },
    { value: "autre", label: "Autre" }
  ],
  renovationMaterialTypes: [
    { value: "pvc", label: "PVC" },
    { value: "aluminium", label: "Aluminium" },
    { value: "bois", label: "Bois" },
    { value: "mixte", label: "Mixte (Bois/Alu)" },
    { value: "ne-sait-pas", label: "Je ne sais pas" }
  ],
  renovationInstallTypes: [
    { value: "renovation", label: "Rénovation (sur dormant existant)" },
    { value: "depose-totale", label: "Dépose totale (remplacement complet)" },
    { value: "a-definir", label: "À définir avec un technicien" }
  ],
  renovationTimelines: [
    { value: "asap", label: "Dès que possible" },
    { value: "1-mois", label: "Sous 1 mois" },
    { value: "3-mois", label: "Sous 3 mois" },
    { value: "a-definir", label: "Date à définir" }
  ]
};

// SEO Keywords for internal linking
export const seoKeywords = {
  primary: [
    "vitrier",
    "vitrier Villiers-sur-Marne",
    "vitrier villiers sur marne",
    "remplacement vitre cassée",
    "vitre cassée",
    "bris de glace"
  ],
  secondary: [
    "vitrier urgence Villiers-sur-Marne",
    "vitrier 24h/24 Villiers-sur-Marne",
    "dépannage vitrerie Villiers-sur-Marne",
    "remplacement vitrage Villiers-sur-Marne",
    "double vitrage Villiers-sur-Marne",
    "réparation vitre Villiers-sur-Marne",
    "artisan vitrier Villiers-sur-Marne",
    "vitrerie Villiers-sur-Marne"
  ]
};
